export default __webpack_public_path__ + "static/media/gijs.07b050f4.png";